import * as angular from "angular";
import { PublicApiService } from "../services/public-api.service";
import { httpHandler } from "../utils/http-handler";

export class PublicApiDataProvider {
    public clients: any[] | null = null;
    public accessTokens: any[] | null = null;

    public clientsPromise: any;
    public accessTokensPromise: any;

    private $q: any;
    private service: PublicApiService;

    constructor($q: any, PublicApiService: PublicApiService) {
        this.$q = $q;
        this.service = PublicApiService;
    }

    all(): Promise<any[]> {
        if (this.clients !== null) {
            return this.$q.resolve(this.clients);
        } else if (this.clientsPromise) {
            //Has been called already and has not resolved yet.
            return this.clientsPromise;
        } else {
            const deferred = this.$q.defer();

            this.service.all().then(
                (response: object) => {
                    const json = response["data"];
                    this.clients = json.data;
                    deferred.resolve(this.clients);
                },
                (error: object) => {
                    this.clients = [];
                    deferred.reject(error);
                }
            );

            this.clientsPromise = deferred.promise;
            return this.clientsPromise;
        }
    }

    allAccessTokens(force: boolean): Promise<any[]> {
        if (this.accessTokens !== null && !force) {
            return this.$q.resolve(this.accessTokens);
        } else if (this.accessTokensPromise && !force) {
            //Has been called already and has not resolved yet.
            return this.accessTokensPromise;
        } else {
            const deferred = this.$q.defer();

            this.service.all_access_tokens().then(
                (response: object) => {
                    const json = response["data"];
                    this.accessTokens = json.data;
                    deferred.resolve(this.accessTokens);
                },
                (error: object) => {
                    this.accessTokens = [];
                    deferred.reject(error);
                }
            );

            this.accessTokensPromise = deferred.promise;
            return this.accessTokensPromise;
        }
    }

    createAccessToken(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.create_access_token().then(
            (response: object) => {
                httpHandler.handleResponse(deferred, response);
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    revokeAccessToken(accessToken: any): Promise<any> {
        const deferred = this.$q.defer();
        this.service
            .revoke_access_token({
                id: accessToken.access_token,
                uid: accessToken.uid,
            })
            .then(
                (response: object) => {
                    httpHandler.handleResponse(deferred, response);
                },
                (error: object) => deferred.reject(error)
            );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("PublicApiDataProvider", PublicApiDataProvider);
